<template>
  <main class="maintenance">
    <div class="maintenance__glow" aria-hidden="true"></div>

    <section class="maintenance__card">
      <img
        class="maintenance__logo"
        :src="logoSrc"
        alt="IpromiseAfrica"
        decoding="async"
        @error="handleLogoError"
      />

      <p class="maintenance__status">
        <span class="maintenance__pulse" aria-hidden="true"></span>
        Under maintenance
      </p>

      <h1>We'll be back shortly</h1>
      <p class="maintenance__copy">
        IpromiseAfrica is temporarily unavailable while we make improvements.
        Please check back in a little while.
      </p>

      <div class="maintenance__actions">
        <button type="button" class="maintenance__refresh" @click="reload">
          <i class="fa-solid fa-rotate" aria-hidden="true"></i>
          Check again
        </button>
        <a class="maintenance__mail" href="mailto:info@ipromiseafrica.com">
          <i class="fa-solid fa-envelope" aria-hidden="true"></i>
          info@ipromiseafrica.com
        </a>
      </div>
    </section>
  </main>
</template>

<script>
import logoSrc from "@/assets/ipalogo.png";

export default {
  name: "MaintenancePage",

  data() {
    return {
      logoSrc,
    };
  },

  mounted() {
    document.title = "Maintenance | IpromiseAfrica";
  },

  methods: {
    reload() {
      window.location.reload();
    },

    handleLogoError(event) {
      event.target.style.display = "none";
    },
  },
};
</script>

<style scoped>
.maintenance {
  min-height: 100vh;
  min-height: 100dvh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: max(24px, env(safe-area-inset-top)) max(20px, env(safe-area-inset-right))
    max(24px, env(safe-area-inset-bottom)) max(20px, env(safe-area-inset-left));
  background:
    radial-gradient(circle at top, rgba(0, 255, 255, 0.12), transparent 42%),
    var(--dashboard-bg);
  color: var(--text-color1);
  box-sizing: border-box;
  position: relative;
  overflow: hidden;
}

.maintenance__glow {
  position: absolute;
  width: min(520px, 90vw);
  height: min(520px, 90vw);
  border-radius: 50%;
  background: radial-gradient(circle, rgba(0, 188, 212, 0.18), transparent 68%);
  pointer-events: none;
}

.maintenance__card {
  position: relative;
  width: min(560px, 100%);
  padding: clamp(28px, 5vw, 48px) clamp(22px, 4vw, 40px);
  border-radius: 28px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  background: var(--card-bg);
  box-shadow: 0 24px 60px rgba(0, 0, 0, 0.35);
  text-align: center;
  box-sizing: border-box;
}

.maintenance__logo {
  width: min(180px, 58vw);
  height: auto;
  margin: 0 auto 22px;
  display: block;
}

.maintenance__status {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin: 0 0 18px;
  padding: 6px 12px;
  border-radius: 999px;
  background: rgba(0, 255, 255, 0.1);
  border: 1px solid rgba(0, 255, 255, 0.28);
  color: var(--border-color-hover);
  font-size: 0.82rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.maintenance__pulse {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: var(--border-color-hover);
  box-shadow: 0 0 0 0 rgba(0, 255, 255, 0.6);
  animation: maintenance-pulse 1.8s infinite;
}

.maintenance__card h1 {
  margin: 0 0 12px;
  font-size: clamp(1.7rem, 4vw, 2.4rem);
  line-height: 1.15;
  color: var(--heading-color);
}

.maintenance__copy {
  margin: 0 auto;
  max-width: 42ch;
  color: var(--subtext-color);
  font-size: 1rem;
  line-height: 1.6;
}

.maintenance__actions {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 14px;
  margin-top: 28px;
}

.maintenance__refresh,
.maintenance__mail {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-height: 44px;
  border-radius: 999px;
  font-family: inherit;
  font-size: 0.95rem;
  font-weight: 700;
  text-decoration: none;
  touch-action: manipulation;
}

.maintenance__refresh {
  padding: 12px 22px;
  border: none;
  background: var(--border-color-hover);
  color: var(--text-color3);
  cursor: pointer;
}

.maintenance__refresh:hover {
  transform: translateY(-2px);
}

.maintenance__mail {
  padding: 10px 16px;
  color: var(--heading-color);
  border: 1px solid rgba(255, 255, 255, 0.16);
}

.maintenance__mail:hover {
  border-color: var(--border-color-hover);
  color: var(--border-color-hover);
}

@keyframes maintenance-pulse {
  0% { box-shadow: 0 0 0 0 rgba(0, 255, 255, 0.55); }
  70% { box-shadow: 0 0 0 8px rgba(0, 255, 255, 0); }
  100% { box-shadow: 0 0 0 0 rgba(0, 255, 255, 0); }
}

@media (max-width: 480px) {
  .maintenance__card {
    border-radius: 22px;
  }

  .maintenance__copy {
    font-size: 0.95rem;
  }
}
</style>
